/**
 * Функционал изменения данных в карточках товаров в блоке "Этим товаром носят"
 * (Этот класс потребуется для дальнейшей логики к карточке, на данный момент логику решили упростить временно)
 *
 * @class GoodCard
 */
class GoodCard {
  #parent;

  constructor(parent) {
    this.#parent = parent;

    this.#init();
  }

  /**
   * Инициализация
   *
   * @memberof GoodCard
   */
  #init() {
    this.onParentMouseOver = this.onParentMouseOver.bind(this);

    if (window.matchMedia("(min-width: 1023px)").matches) {
      this.#parent.addEventListener(`mouseover`, this.onParentMouseOver);
    }
  }

  /**
   * Смена изображений при наведении в карточке товара
   *
   * @param {*} parent
   * @param {*} control
   * @memberof GoodCard
   */
  #changeImage(parent, control) {
    const currentIndex = +control.dataset.id;
    const sourceElement = parent.querySelector(`source:not([media="(max-width: 767px)"])`);
    const imgElement = parent.querySelector(`img`);
    const bulletElements = parent.querySelectorAll(`.js-bullet`);

    bulletElements.forEach((element) => element.classList.remove(`good-card__bullet--active`));

    if (sourceElement) {
      sourceElement.srcset = control.dataset.webp;
    }

    imgElement.src = control.dataset.src;
    bulletElements[currentIndex].classList.add(`good-card__bullet--active`);
  }

  /**
   * Слушатель наведения курсора на родителя изображения карточки товара для смены изображений
   *
   * @param {*} event
   * @memberof GoodCard
   */
  onParentMouseOver(event) {
    const target = event.target;

    if (target.closest(`.js-img-box`)) {
      this.#changeImage(target.closest(`.js-img-box`), target);
    }
  }
}

export {GoodCard};
